module["exports"] = [
  "ახალი",
  "ძველი",
  "ზემო",
  "ქვემო"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ge/address/city_prefix.js
// module id = 1223
// module chunks = 0